import React from 'react'
import ScalabilityService from './scalabilityService/ScalabilityService'
import ScalabilityTestimonial from './scalabilityTestimonial/ScalabilityTestimonial'
import ScalabilityScalee from './scalabilityScale/ScalabilityScalee'
import ScalabilityImplement from './ScalabilityImplement/ScalabilityImplement'
import ScalabilityCapable from './scalabilityCapable/ScalabilityCapable'
import ScalabilityWhat from './scalabilityWhat/ScalabilityWhat'
import ScalabilityChoose from './scalabilityChoose/ScalabilityChoose'
import ScalabilityHero from './scalabilityHero/ScalabilityHero'
import ScalabilityScroll from './scalabilityScroll/ScalabilityScroll'

export default function Scalability() {
  return (
    <div>
        <ScalabilityHero/>
        <ScalabilityWhat/>
        <ScalabilityCapable/>
        <ScalabilityScroll/>
        <ScalabilityImplement/>
        <ScalabilityChoose/>
        <ScalabilityScalee/>
        <ScalabilityTestimonial/>
        <ScalabilityService/>
    </div>
  )
}
